"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const util_1 = require("../../../util");
const Badge = (prop) => {
    const { text, color, icon, close } = prop;
    return (react_1.default.createElement("div", { className: (0, util_1.cnx)(`glx-badge`, [!!color, ` glx-badge--${color}`]) },
        icon ? (0, react_icons_1.getIcon)(icon)({}) : null,
        text,
        close ? (react_1.default.createElement("button", { onClick: close },
            react_1.default.createElement(react_icons_1.IOClose, null))) : null));
};
Badge.defaultProps = {
    color: undefined,
    text: undefined,
    icon: undefined,
    close: undefined,
};
exports.default = Badge;
